export default __webpack_public_path__ + "images/WZ.dd4894b.png";